import { Clickable } from '@carvana/vdp-components';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import Close from '~/icons/Close';

function NewPriceSaveSearch({ onClose }) {
  const [isWhite, setIsWhite] = useState(false);
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
    onClose();
  };

  useEffect(() => {
    setTimeout(() => {
      setIsWhite(true);
    }, 2000);
  }, []);

  return isOpen ? (
    <div
      className={classnames(
        'border border-grey-2 duration-500 ease-in flex items-center justify-between mb-16 px-16 py-8 relative rounded t-header-xs text-blue-6 transition-colors m:mb-32',
        { 'bg-white': isWhite, 'bg-[#EAFCF4]': !isWhite }
      )}
      data-qa="new-price-save-search"
    >
      Save this search to receive new price updates
      <div
        className={classnames(
          'absolute border duration-500 border-b-0 border-grey-2 border-l border-r-0 border-t ease-in h-12 right-56 rotate-45 rounded-tl top-[-7px] transition-colors w-12',
          { 'bg-white': isWhite, 'bg-[#EAFCF4]': !isWhite }
        )}
      />
      <Clickable
        data-analytics-id="New Price - Close Save Search Banner"
        onClick={handleClose}
        className="flex"
      >
        <Close className="fill-grey-5 right-16 top-16" width={16} />
      </Clickable>
    </div>
  ) : null;
}

export default NewPriceSaveSearch;
